export default "<ng-template [cdkPortalOutlet]=\"chipComponentPortal\"></ng-template>\n"